import React, { Component } from 'react';

import ScrollableText from 'react/views/generic/ScrollableText';
import { Card } from 'react/card/Card';
import TrackedLink from '../generic/TrackedLink';
import CardCarousel from 'react/views/carousel/CardCarousel';
import ResultsModal from 'react/views/generic/ResultsModal';
import TruncateText from '../generic/TruncateText';
import CardTitle from 'react/card/CardTitle';
import CardFooter from 'react/card/CardFooter';

import '../../card/cardContent.less';
import './libraryPosts.less';
import LibraryAwareNewsEventTypes from 'data/types/LibraryAwareNewsEventTypes';

const ItemHeight = '175px';

class LibraryPostsView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isModalOpen: false,
			iFrameStyle: { visibility: 'hidden' },
			iFrameUrl: null,
			iFrameTitle: null,
			displayDescription: props.cardModel[0].description
		};

		this.openModal = this.openModal.bind(this);
		this.dataLoaded = this.dataLoaded.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.reportUpdate = this.reportUpdate.bind(this);
	}

	openModal(url, title) {
		this.setState({
			isModalOpen: true,
			isLoading: true,
			iFrameStyle: { visibility: 'hidden' },
			iFrameUrl: url,
			iFrameTitle: title
		});
	}

	closeModal() {
		this.setState({
			isModalOpen: false,
			isLoading: false,
			iFrameStyle: { visibility: 'hidden' }
		})
	}

	dataLoaded() {
		this.setState({
			isLoading: false,
			iFrameStyle: { visibility: 'visible' }
		});
	}

	renderPosts() {
		return this.props.cardModel.map((post, index) => {
			return this.renderPost(post);
		});
	}

	reportUpdate(index) {
		this.setState({
			displayDescription: this.props.cardModel[index].description
		});
	}

	renderPost(post) {
		return (
			<div className="post-container">
				<div className="post-anchor">
					<TrackedLink featureType={LibraryAwareNewsEventTypes.LIBRARYNEWS_NAME_CLICKED} destId={post.title}>
						<span className="clickable" style={{color:"black"}} onClick={() => this.openModal(post.url, post.title)}>
							<img className="post-jacket" src={post.imageurl} alt={post.title} />
							<a href="javascript:void(0)"><TruncateText className="post-link" line={3} truncateText="..." text={post.title} /></a>
						</span>
					</TrackedLink>
				</div>
			</div>
		);
	}

	render() {
		return (
			<Card>
				<CardTitle title="Library News"/>
				<CardCarousel components={this.renderPosts()} itemHeight={ItemHeight} reportUpdate={this.reportUpdate} />
				<div className="post-description">
					<ScrollableText line={5}>
						{this.state.displayDescription}
					</ScrollableText>
				</div>
				<ResultsModal modalTitle={this.state.iFrameTitle} isLoading={this.state.isLoading} isOpen={this.state.isModalOpen} close={this.closeModal}>
					<iframe title='Library News' src={this.state.iFrameUrl} height='100%' width='100%' style={this.state.iFrameStyle}
						onLoad={this.dataLoaded} />
				</ResultsModal>
				<CardFooter />
			</Card>
		);
	}
}

export default LibraryPostsView;



// WEBPACK FOOTER //
// ./src/react/views/libraryposts/LibraryPostsView.jsx